import PowersportsAsset from '../asset/powersports-asset';
import configuration from '../configuration';
import GenericCta from './generic-cta';
import { infoSvgComponent } from '../util/svg-component';

export default class PowersportsCta extends GenericCta<PowersportsAsset> {
  buildCtaElement(asset: PowersportsAsset, rate: number): HTMLElement {
    if (this.style === 'cfmoto-summary') {
      return this.buildCFMotoSummaryCtaElement();
    } else if (this.style === 'oval') {
      return this.buildOvalCtaElement(asset, rate);
    } else {
      return super.buildCtaElement(asset, rate);
    }
  }

  buildCFMotoSummaryCtaElement(): HTMLElement {
    // CTA Container
    const cta = document.createElement('a');
    cta.classList.add('ol-cta', 'ol-cta-summary');
    cta.addEventListener('click', this.handleOnClick.bind(this));
    cta.innerHTML = `
      <div class="ol-button-text-summary" data-links-initialized="false">
        <span>${configuration.cta_text}</span>
      </div>
    `;

    return cta;
  }

  buildOvalCtaElement(asset: PowersportsAsset, rate: number): HTMLElement {
    // CTA Container
    const cta = document.createElement('a');
    // Add generic CTA classes
    cta.classList.add('ol-cta-oval');

    // Prepare buttonContainer
    const buttonContainer = document.createElement('div');
    buttonContainer.addEventListener('click', this.handleOnClick.bind(this));
    buttonContainer.classList.add('ol-button-container-oval', 'ol-button-container-search');
    buttonContainer.innerHTML = `
    <div class="oval-button ol-button-oval" data-links-initialized="false">
      <span class="ol-button-text-oval">${configuration.cta_text}</span>
    </div>
    `;

    cta.innerHTML = `
    <div class="ol-msrp-container ol-msrp-container-search">
      <div class="ol-rate-container-search">
        <div class="ol-tooltip-link-oval">
          <p class="ol-msrp-oval">from</p>
          <p class="ol-title-oval ol-msrp-oval">$${rate}/mo</p>
          ${infoSvgComponent().outerHTML}
        </div>
      </div>
      <p class="ol-msrp-subtitle-oval">Instant | No credit impact</p>
    </div>
    `;

    cta.append(buttonContainer);

    return cta;
  }
}
